<!--账号管理-->
<template>
  <div class="account-container" :style="'min-height:'+min_height+'px;'">
    <headerIndex/>
    <div class="account-header">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#FFFFFF"  @select="handleSelect2"
               text-color="#333333" active-text-color="#FE273B" router active-background-color="#FE273B">
        <el-menu-item :index="navigation.href" v-for="navigation of navigationBar">{{ navigation.name }}</el-menu-item>
      </el-menu>
    </div>
    <div class="left-header" :style="'min-height:'+min_heights+'px;'">
      <el-container>
        <el-aside width="180px" style="background: #ffffff">
          <el-menu :default-active="activeIndex2" class="el-menu-vertical-demo" @select="handleSelect"
                   background-color="#FFFFFF" active-text-color="#FE273B">
            <el-menu-item :index="vertical.href" v-for="vertical of navigationBar2">{{ vertical.name }}</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <bind-mobile v-if="activeIndex2=='/accountManagement/bindMobile'"/>
          <certification v-if="activeIndex2=='/accountManagement/certification'"/>
          <login-password v-if="activeIndex2=='/accountManagement/loginPassword'"/>
          <bind-email v-if="activeIndex2=='/accountManagement/bindEmail'"/>
          <login-protection v-if="activeIndex2=='/accountManagement/loginProtection'"/>
        </el-main>
      </el-container>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import BindMobile from "@/views/accountManagement/bindMobile";
import Certification from "@/views/accountManagement/certification";
import LoginPassword from "@/views/accountManagement/loginPassword";
import BindEmail from "@/views/accountManagement/bindEmail";
import LoginProtection from "@/views/accountManagement/loginProtection";
import Hang from "@/components/Hang/Hang";
import Home_footer from "@/components/footer/home_footer";
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
Vue.use(VXETable)
export default {
  name: "index",
  components: {Home_footer, Hang, LoginProtection, BindEmail, LoginPassword, Certification, BindMobile, headerIndex},
  data() {
    return {
      activeIndex: '/accountManagement/index',
      navigationBar: [
        {name: '订单管理', index: 1, href: '/orderManagement/index'},
        {name: '个人中心', index: 2, href: '/personal/index'},
        {name: '账号管理', index: 3, href: '/accountManagement/index'},
        // {name: '在线客服', index: 4, href: ''}
      ],
      min_height: document.documentElement.clientHeight,
      min_heights: document.documentElement.clientHeight - 346,
      activeIndex2: '/accountManagement/bindMobile',
      navigationBar2: [
        {name: '绑定手机', index: 1, href: '/accountManagement/bindMobile'},
        {name: '实名认证', index: 2, href: '/accountManagement/certification'},
        {name: '登录密码', index: 3, href: '/accountManagement/loginPassword'},
        {name: '邮箱绑定', index: 4, href: '/accountManagement/bindEmail'},
        {name: '登录保护', index: 5, href: '/accountManagement/loginProtection'}
      ],
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex2 = key;
      localStorage.setItem('accountIndex', key);
    },
    handleSelect2(key){
      if (key!=''){}else{
        let routeData = this.$router.resolve({
          name: "onlineService",
          path: '/onlineService/index'
        });
        window.open(routeData.href, '_blank')
      }
    }
  },
  mounted() {
    this.activeIndex2 = localStorage.getItem('accountIndex') ? localStorage.getItem('accountIndex') : '/accountManagement/bindMobile';
  }
}
</script>
<style scoped>
.account-container >>> .account-header .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px;
  line-height: 50px;
  margin: 0px 50px 0px 0px;
  padding: 0 0px;
  border-bottom: 2px solid transparent;
  color: #333333;
  font-size: 16px;
}

.account-container >>> .left-header .el-menu-item {
  height: auto;
  line-height: normal;
  font-size: 14px;
  color: #333333;
  padding: 20px 20px;
  border-bottom: 1px solid #F1F1F1;
}

.account-container >>> .left-header .el-card__body, .el-main {
  padding: 0px 0px 0px 10px;
}
.account-container >>> .left-header .el-menu-item.is-active {
  border-right: 2px solid;
}
</style>
<style scoped lang="scss">
.account-container {
  background: #F1F1F1;

  .account-header {
    padding: 0px 18%;
    min-width: 76rem;
    background: #ffffff;
  }

  .left-header {
    padding: 10px 18%;
    min-width: 76rem;
    background: #F1F1F1;
  }
}
</style>
